import { render, staticRenderFns } from "./edit-catalog-item-modal.vue?vue&type=template&id=0716e806&scoped=true&"
import script from "./edit-catalog-item-modal.vue?vue&type=script&lang=js&"
export * from "./edit-catalog-item-modal.vue?vue&type=script&lang=js&"
import style0 from "./edit-catalog-item-modal.vue?vue&type=style&index=0&id=0716e806&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0716e806",
  null
  
)

export default component.exports